import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['feedback']

  start() {
    this.feedbackTarget.classList.remove('text-state-bad', 'text-state-ok')
    this.feedbackTarget.classList.add('text-ink-muted')
    this.feedbackTarget.textContent = 'Checking mailbox access…'
  }

  finish(event) {
    if (!event.detail.success && this.element.isConnected &&
        !event.detail.fetchResponse?.contentType?.startsWith('text/vnd.turbo-stream.html')) {
      this.failed()
    }
  }

  missing(event) {
    event.preventDefault()
    this.failed()
  }

  failed() {
    this.feedbackTarget.classList.remove('text-ink-muted', 'text-state-ok')
    this.feedbackTarget.classList.add('text-state-bad')
    this.feedbackTarget.textContent = 'Mailbox access could not be checked. Please try again.'
  }
}
